import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import ShortCoveringFull from './short-covering-full';

const ShortCoveringFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <ShortCoveringFull {...props} />
    </QueryClientProvider>
  );
};

export { ShortCoveringFullWidget }
